import request from '@/utils/request'
import qs from 'qs'

export function login(data) {
  // data.client_id=1;
  console.log(data,"lalalaa");

  var logindata=qs.stringify(data);
  console.log(logindata,"qwoe")
  return request({
    url: '/api/auth/userlogin',
    method: 'post',
    data:logindata,
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
  })
}

// export function listInfo() {
//   console.log('lisy')
//   return request({
//     url: '/api/pen/note/list',
//     method: 'get',
    
//   })
// }

export function getInfo(token) {
  return request({
    url: '/api/user',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/vue-admin-template/user/logout',
    method: 'post'
  })
}
